<ng-container [ngSwitch]="inputElementType">
  <ng-template [ngSwitchCase]="'AlphaNumericWithSpace'">
    <input
      [name]="element.name"
      [attr.id]="element.name"
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="txtVal"
      (keydown)="valueChange($event)"
      (blur)="utilService.flushDebounce(debounceValChanges)"
      [disabled]="disableField || formFieldDisable"
      alphaNumWithSpace
      [maxlength]="maxChars"
    />
  </ng-template>
  <ng-template [ngSwitchCase]="'FieldLabel'">
    <input
      [name]="element.name"
      [attr.id]="element.name"
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="txtVal"
      (keydown)="valueChange($event)"
      [disabled]="disableField || formFieldDisable"
      (blur)="utilService.flushDebounce(debounceValChanges)"
    />
  </ng-template>
  <ng-template [ngSwitchCase]="'default'">
    <input
      [name]="element.name"
      [attr.id]="element.name"
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="txtVal"
      (keydown)="valueChange($event)"
      (blur)="utilService.flushDebounce(debounceValChanges)"
      [disabled]="disableField || formFieldDisable"
    />
  </ng-template>
</ng-container>
